module.exports = __webpack_public_path__ + "src/assets/img/fz.1fd784bf.png";